import React, { useState } from "react";
import { Container, Row, Col, Form, Button, ListGroup } from "react-bootstrap";

// Données simulées de messages reçus de l'école
const messagesFromSchool = [
  {
    id: 1,
    subject: "Rappel des frais",
    content: "Veuillez régler vos frais avant le 30 octobre.",
  },
  {
    id: 2,
    subject: "Journée portes ouvertes",
    content: "Ne manquez pas notre événement le 25 novembre.",
  },
  {
    id: 3,
    subject: "Nouvelle formation",
    content: "Découvrez nos nouvelles formations en ligne.",
  },
];

export default function Messagerie() {
  const [selectedMessage, setSelectedMessage] = useState(null);
  const [emailSubject, setEmailSubject] = useState("");
  const [emailContent, setEmailContent] = useState("");

  const handleSelectMessage = (message) => {
    setSelectedMessage(message);
  };

  const handleSendEmail = () => {
    if (emailSubject.trim() && emailContent.trim()) {
      alert(
        `Email envoyé avec succès:\nSujet: ${emailSubject}\nMessage: ${emailContent}`
      );
      setEmailSubject(""); // Réinitialisation des champs
      setEmailContent("");
    }
  };

  return (
    <Container fluid className="py-5">
      <h1 className="text-center mb-4">Messagerie</h1>
      <Row>
        {/* Liste des messages reçus */}
        <Col md={4} className="border-end">
          <h5 className="mb-3">Messages reçus</h5>
          <ListGroup>
            {messagesFromSchool.map((msg) => (
              <ListGroup.Item
                key={msg.id}
                action
                active={selectedMessage?.id === msg.id}
                onClick={() => handleSelectMessage(msg)}
              >
                <strong>{msg.subject}</strong>
              </ListGroup.Item>
            ))}
          </ListGroup>
        </Col>

        {/* Contenu du message sélectionné */}
        <Col md={8} className="mb-3">
          <div
            className="border rounded p-3"
            style={{ height: "200px", overflowY: "auto" }}
          >
            {selectedMessage ? (
              <>
                <h5>{selectedMessage.subject}</h5>
                <p>{selectedMessage.content}</p>
              </>
            ) : (
              <p>Sélectionnez un message pour l’afficher.</p>
            )}
          </div>
        </Col>
      </Row>
    </Container>
  );
}
